/* eslint-disable no-nested-ternary */
import React, { memo, useMemo } from "react";

import TopSection from "./TopSection";
import BottomSection from "./BottomSection";

import { useAdminPermission } from "../../hooks/useAdminPermission";
import { useAuth } from "../../hooks/useAuth";

import { BottomWrapper, Container, Wrapper } from "./styles";

const Header = ({ hiddenMenu }) => {
  const { user } = useAuth();
  const isAdmin = useAdminPermission();
  const headerMenuShow = isAdmin || !hiddenMenu || !user?.id;

  const getHeaderHeight = useMemo(
    () => (user?.id && !isAdmin ? (hiddenMenu ? "64px" : "123px") : "109px"),
    [user?.id, isAdmin, hiddenMenu],
  );

  return (
    <Container $height={getHeaderHeight}>
      <Wrapper direction="column">
        <TopSection hiddenMenu={headerMenuShow} />

        {headerMenuShow && (
          <BottomWrapper>
            <BottomSection />
          </BottomWrapper>
        )}
      </Wrapper>
    </Container>
  );
};
export default memo(Header);
